var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptysearchscreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 537.181,
    height: 262.593,
    viewBox: "0 0 537.181 262.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e8505b;}.b{fill:url(#a);}.c{fill:#fff;}.d{fill:#263238;}.e{fill:#455a64;}.f{fill:#ebebeb;}.g{fill:#e0e0e0;}.h{fill:#ffbe9d;}.i{fill:#eb996e;}.j{fill:#fafafa;}.k{fill:#f5f5f5;}.l{fill:#ccc;}.m{fill:#e6e6e6;}.n{fill:#2f2e41;}.o{fill:#efefef;}.p{fill:#3f3d56;}.q{filter:url(#t);}.r{filter:url(#q);}.s{filter:url(#n);}.t{filter:url(#k);}.u{filter:url(#h);}.v{filter:url(#e);}.w{filter:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.982,
    y1: 0.015,
    x2: 0.015,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7eaeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288,
    stopColor: "#4583ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#427bdd",
    stopOpacity: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#759fe6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 133.288,
    y: 27.932,
    width: 211.516,
    height: 133.721,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 129.924,
    y: 79.792,
    width: 234.623,
    height: 149.915,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 34.563,
    y: 99.639,
    width: 94.516,
    height: 157.617,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "i"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "i"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 52.199,
    y: 98.743,
    width: 95.296,
    height: 163.85,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "l"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    x: 424.604,
    y: 110.134,
    width: 112.149,
    height: 148.206,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "o"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "o"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    x: 431.021,
    y: 32.799,
    width: 74.878,
    height: 114.147,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "r"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "r"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "t",
    x: 407.58,
    y: 58.732,
    width: 62.857,
    height: 64.286,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "u"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "u"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-328.954 -445.025)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(378.092 445.025)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.786 2.781)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.364 35.151)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M232.277,189.293l5.334,90.939a6.141,6.141,0,0,0,6.112,5.782l163.683.5a6.142,6.142,0,0,0,6.16-6.123l.216-70.8a6.141,6.141,0,0,0-6.162-6.16l-100.665.341a6.14,6.14,0,0,1-4.343-1.78L285.168,184.7a6.143,6.143,0,0,0-4.3-1.78l-42.437-.129A6.141,6.141,0,0,0,232.277,189.293Z",
    transform: "translate(-232.267 -182.792)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "matrix(1, 0, 0, 1, -148.29, -37.93)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M232.277,189.293l5.334,90.939a6.141,6.141,0,0,0,6.112,5.782l163.683.5a6.142,6.142,0,0,0,6.16-6.123l.216-70.8a6.141,6.141,0,0,0-6.162-6.16l-100.665.341a6.14,6.14,0,0,1-4.343-1.78L285.168,184.7a6.143,6.143,0,0,0-4.3-1.78l-42.437-.129A6.141,6.141,0,0,0,232.277,189.293Z",
    transform: "translate(-83.98 -144.86)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.987 0.959)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 88.827,
    height: 71.015,
    transform: "matrix(0.606, -0.795, 0.795, 0.606, 0.247, 70.661)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M288.489,137.527s-.085.122-.252.347l-.745.995-2.9,3.847-10.979,14.49L234.8,208.294l-.034-.246,56.5,43.011.006,0L291,251.1l53.852-70.64.031.23L303.948,149.4l-11.421-8.753-3.006-2.313c-.681-.526-1.033-.81-1.033-.81s.347.25,1.027.759l3,2.265,11.443,8.663,41.117,31.215.131.1-.1.131-53.8,70.68-.119.156-.156-.119-.006,0-56.473-43.044-.141-.107.107-.14,39.015-51.073,11.029-14.4,2.916-3.794.75-.968C288.4,137.63,288.489,137.527,288.489,137.527Z",
    transform: "translate(-234.415 -137.527)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 82.586,
    height: 62.074,
    transform: "matrix(0.606, -0.795, 0.795, 0.606, 5.659, 70.934)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M303,260.982l-13.214-46.327,30.031.414-2.922-17.461,36.15-2.323Z",
    transform: "translate(-247.96 -151.657)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.225 36.961)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.503,
    cy: 6.503,
    r: 6.503,
    transform: "translate(0 1.758) rotate(-7.768)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.726)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 98.842,
    height: 123.634,
    transform: "matrix(0.041, -0.999, 0.999, 0.041, 0.205, 98.941)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M443.946,141.522s-.2,0-.591-.014l-1.725-.061-6.7-.255-25.275-.993-89.247-3.583.183-.168c-1.2,29.392-2.582,63.091-4.041,98.748v.011l-.188-.2,123.527,5.115-.17.156c1.26-29.761,2.3-54.43,3.033-71.665.373-8.624.666-15.388.866-20,.1-2.3.181-4.071.235-5.268s.093-1.817.093-1.817-.013.6-.055,1.783-.111,2.947-.2,5.238c-.18,4.607-.443,11.358-.779,19.969-.69,17.262-1.677,41.967-2.868,71.775l-.007.163-.163-.007L316.346,235.4l-.2-.008.008-.2v-.011c1.474-35.658,2.867-69.356,4.083-98.747l.007-.176.176.008,89.353,3.763,25.232,1.085,6.661.3,1.706.08C443.757,141.507,443.946,141.522,443.946,141.522Z",
    transform: "translate(-316.149 -136.257)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 86.397,
    height: 114.948,
    transform: "translate(4.719 92.899) rotate(-87.644)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M322.4,242.4l42.322-52.008,23.468,34.593,17.592-17.253,31.469,39.393Z",
    transform: "translate(-317.677 -149.5)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.854 24.591)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 9.051,
    cy: 9.051,
    r: 9.051,
    transform: "matrix(0.219, -0.976, 0.976, 0.219, 0, 17.663)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.977 18.843)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M439.059,199.428,271.73,222.467,289.448,345.02l165.96-23.378Z",
    transform: "translate(-265.534 -170.554)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M440.533,179.188,275.141,213.471l25.951,121.078,164-34.529Z",
    transform: "translate(-266.368 -165.602)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M423.163,161.2,263.83,217.262l41.886,116.528,157.924-56.118Z",
    transform: "translate(-263.601 -161.203)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M423.088,161.2c.437,1.249,16.015,45.889,40.628,116.416l.053.151-.15.053L305.707,333.976l-.184.066-.066-.184-.306-.85c-14.906-41.491-29.041-80.83-41.563-115.684l-.06-.169.169-.06L423.088,161.2,263.815,217.43l.109-.228c12.532,34.85,26.678,74.185,41.6,115.672l.306.85-.251-.119,157.936-56.085-.1.2C438.984,207.133,423.521,162.452,423.088,161.2Z",
    transform: "translate(-263.527 -161.203)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130.956 22.589)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M469.988,280.286c-.305.113-7.96-19.76-17.095-44.382s-16.3-44.683-15.99-44.8,7.959,19.755,17.1,44.386S470.294,280.172,469.988,280.286Z",
    transform: "translate(-436.895 -191.107)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117.348 28.809)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M451.974,288.52c-.306.113-7.961-19.76-17.1-44.382s-16.3-44.683-15.99-44.8,7.959,19.755,17.1,44.386S452.279,288.406,451.974,288.52Z",
    transform: "translate(-418.879 -199.341)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.1 46.505)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M396.043,311.947c-.306.113-7.961-19.76-17.1-44.382s-16.3-44.683-15.99-44.8,7.959,19.755,17.1,44.386S396.348,311.833,396.043,311.947Z",
    transform: "translate(-362.948 -222.768)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.565 41.083)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M413.869,304.769c-.306.113-7.96-19.76-17.095-44.382s-16.3-44.683-15.99-44.8,7.959,19.755,17.1,44.385S414.174,304.655,413.869,304.769Z",
    transform: "translate(-380.775 -215.59)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.031 35.66)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M431.7,297.59c-.305.113-7.96-19.76-17.095-44.382s-16.3-44.684-15.99-44.8,7.958,19.756,17.1,44.386S432,297.477,431.7,297.59Z",
    transform: "translate(-398.602 -208.411)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.502 50.992)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M375.394,317.888c-.306.113-7.96-19.76-17.095-44.382s-16.3-44.683-15.99-44.8,7.959,19.756,17.1,44.386S375.7,317.775,375.394,317.888Z",
    transform: "translate(-342.3 -228.709)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.585 56.463)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M355.646,325.13c-.306.113-7.96-19.76-17.095-44.382s-16.3-44.683-15.99-44.8,7.959,19.755,17.1,44.386S355.951,325.017,355.646,325.13Z",
    transform: "translate(-322.552 -235.951)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.668 61.933)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M335.9,332.372c-.306.114-7.96-19.759-17.095-44.382s-16.3-44.683-15.99-44.8,7.959,19.755,17.1,44.386S336.2,332.258,335.9,332.372Z",
    transform: "translate(-302.804 -243.193)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "v",
    transform: "matrix(1, 0, 0, 1, -144.92, -2.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M227.842,255.865l13.315,111.486a3.95,3.95,0,0,0,3.91,3.481l174.294.531a3.948,3.948,0,0,0,3.948-3.627l9.115-111.418a3.949,3.949,0,0,0-3.924-4.271l-196.724-.6A3.949,3.949,0,0,0,227.842,255.865Z",
    transform: "translate(-82.89 -161.66)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 108.743)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.177 129.116)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.156)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M201.827,453.665l-.073-6.2-11.61.061.009,9.068.721.042c3.2.161,16.305.594,18.444-.067C211.7,455.835,201.827,453.665,201.827,453.665Z",
    transform: "translate(-190.145 -447.467)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.781)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M189.939,459.174a1.069,1.069,0,0,0,.2.02l.573.032,2.11.081c1.783.056,4.247.1,6.968.09s5.186-.074,6.967-.144l2.11-.1.573-.036a1.177,1.177,0,0,0,.2-.023,1.1,1.1,0,0,0-.2-.006l-.575.01-2.11.053c-1.782.045-4.244.092-6.965.1s-5.183-.018-6.965-.049l-2.111-.036-.575-.005A1,1,0,0,0,189.939,459.174Z",
    transform: "translate(-189.939 -459.092)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.622 7.287)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M210.641,458.937a4.717,4.717,0,0,1,.389-1.009,4.775,4.775,0,0,1,.716-.811,1.874,1.874,0,0,0-1.105,1.82Z",
    transform: "translate(-210.62 -457.113)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.203 6.418)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M206.1,456.934c.032.02.2-.18.364-.447s.277-.5.245-.522-.2.18-.364.447S206.067,456.913,206.1,456.934Z",
    transform: "translate(-206.094 -455.963)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.263 6.237)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M204.853,456.383c.026.029.209-.094.408-.275s.34-.35.313-.379-.208.094-.408.275S204.827,456.354,204.853,456.383Z",
    transform: "translate(-204.85 -455.725)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.667 5.736)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M204.061,455.127a2.655,2.655,0,1,0,.607-.066A1.357,1.357,0,0,0,204.061,455.127Z",
    transform: "translate(-204.061 -455.061)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.459 5.019)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M203.786,454.123a1.708,1.708,0,0,0,1.374.1,3.64,3.64,0,0,0-.687-.045A3.754,3.754,0,0,0,203.786,454.123Z",
    transform: "translate(-203.785 -454.111)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.598 5.323)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M206.617,455.565a2.157,2.157,0,0,0,.746-.008,4.37,4.37,0,0,0,.793-.179,2.169,2.169,0,0,0,.454-.189.407.407,0,0,0,.184-.233.294.294,0,0,0-.115-.3,1.368,1.368,0,0,0-1.69.409,1.33,1.33,0,0,0-.241.5.415.415,0,0,0-.019.2,2.118,2.118,0,0,1,.337-.638,1.349,1.349,0,0,1,.636-.417,1.155,1.155,0,0,1,.889.057c.119.087.073.227-.058.306a2.248,2.248,0,0,1-.418.181,5.183,5.183,0,0,1-.767.2C206.9,455.54,206.617,455.541,206.617,455.565Z",
    transform: "translate(-206.617 -454.514)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.812 4.969)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M206.556,455.485a.734.734,0,0,0,.084-.518,1.22,1.22,0,0,0-.206-.544.75.75,0,0,0-.623-.378.3.3,0,0,0-.228.346.81.81,0,0,0,.128.332,2.28,2.28,0,0,0,.354.45,1.08,1.08,0,0,0,.428.3c.013-.018-.15-.133-.356-.369a2.646,2.646,0,0,1-.315-.446c-.1-.157-.174-.44.013-.474.187-.019.378.166.492.314a1.223,1.223,0,0,1,.214.484A2.733,2.733,0,0,1,206.556,455.485Z",
    transform: "translate(-205.577 -454.045)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.222 5.605)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M190.233,454.968c0,.026.332-.033.857.026a3.637,3.637,0,0,1,3.052,2.41c.179.5.2.831.224.828a.687.687,0,0,0,0-.234,3.048,3.048,0,0,0-.13-.625,3.527,3.527,0,0,0-3.137-2.478,3.059,3.059,0,0,0-.638.02A.674.674,0,0,0,190.233,454.968Z",
    transform: "translate(-190.233 -454.887)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.311 0.848)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M191.767,448.59a40.332,40.332,0,0,0-.039,4.772,40.771,40.771,0,0,0,.039-4.772Z",
    transform: "translate(-191.675 -448.59)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.83 7.863)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M197.657,457.891a9.531,9.531,0,0,0,3.393.016c0-.041-.762.009-1.7,0S197.662,457.85,197.657,457.891Z",
    transform: "translate(-197.657 -457.877)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.549 7.88)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M194.642,457.9c-.028.029.063.16.141.334s.122.328.162.325.059-.184-.034-.384S194.667,457.876,194.642,457.9Z",
    transform: "translate(-194.637 -457.899)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.686 6.815)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M193.5,456.5c-.028.028.048.148.168.27s.241.2.268.169-.048-.147-.168-.269S193.528,456.468,193.5,456.5Z",
    transform: "translate(-193.495 -456.49)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.462 6.272)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M191.875,455.837c.008.039.162.037.333.1s.295.15.325.123-.067-.187-.28-.257S191.863,455.8,191.875,455.837Z",
    transform: "translate(-191.874 -455.77)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.586 6.086)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M190.716,455.551c-.014.036.054.1.15.132s.187.038.2,0-.053-.1-.15-.133S190.731,455.515,190.716,455.551Z",
    transform: "translate(-190.715 -455.525)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 114.908)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M112.418,440.124l3.28-5.26-9.812-6.206-4.88,7.644.584.424c2.612,1.863,13.415,9.288,15.572,9.884C119.568,447.274,112.418,440.124,112.418,440.124Z",
    transform: "translate(-101.006 -428.658)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.004 7.33)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M101.012,438.362a.981.981,0,0,0,.156.125l.466.336,1.734,1.206c1.471,1.008,3.523,2.373,5.82,3.831s4.408,2.732,5.947,3.634l1.83,1.055.5.278a.1.1,0,1,0,.014-.024l-.489-.3-1.806-1.093c-1.525-.923-3.625-2.21-5.923-3.667s-4.355-2.808-5.84-3.795l-1.759-1.169-.48-.314A1.2,1.2,0,0,0,101.012,438.362Z",
    transform: "translate(-101.012 -438.362)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.045 14.995)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M118.278,449.483a3.072,3.072,0,0,1,1.912-.937,1.873,1.873,0,0,0-1.912.937Z",
    transform: "translate(-118.275 -448.509)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.083 12.171)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M115.679,445.268c.017.035.261-.046.548-.181s.5-.273.487-.308-.261.046-.548.181S115.662,445.233,115.679,445.268Z",
    transform: "translate(-115.678 -444.771)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.555 11.557)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M114.979,444.146c.007.038.227.033.492-.012s.474-.112.468-.15-.227-.033-.492.011S114.973,444.108,114.979,444.146Z",
    transform: "translate(-114.979 -443.958)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.638 10.496)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M115.091,442.558c-.021.033.19.207.471.39s.526.3.547.271-.19-.207-.471-.39S115.112,442.526,115.091,442.558Z",
    transform: "translate(-115.089 -442.553)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.877 9.737)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M115.409,441.55c-.029.023.149.293.466.528a1.175,1.175,0,0,0,.64.295c.016-.037-.256-.182-.556-.407S115.441,441.525,115.409,441.55Z",
    transform: "translate(-115.406 -441.548)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.944 11.72)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M116.832,444.477a2.145,2.145,0,0,0,.633.4,4.336,4.336,0,0,0,.764.277,2.173,2.173,0,0,0,.484.085.4.4,0,0,0,.28-.1.293.293,0,0,0,.064-.313,1.369,1.369,0,0,0-1.644-.567,1.342,1.342,0,0,0-.472.291c-.094.092-.131.154-.124.16a2.092,2.092,0,0,1,.627-.357,1.352,1.352,0,0,1,.761-.008,1.156,1.156,0,0,1,.718.526c.054.137-.06.23-.214.227a2.2,2.2,0,0,1-.45-.073,5.206,5.206,0,0,1-.756-.242C117.085,444.609,116.844,444.457,116.832,444.477Z",
    transform: "translate(-116.818 -444.174)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.799 10.52)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M116.929,444.223c0,.013.2-.089.35-.391a1.227,1.227,0,0,0,.119-.57.75.75,0,0,0-.321-.654.3.3,0,0,0-.378.168.809.809,0,0,0-.072.35,2.248,2.248,0,0,0,.057.57,1.072,1.072,0,0,0,.2.483c.021-.008-.054-.193-.1-.5a2.578,2.578,0,0,1-.024-.545c0-.188.09-.465.266-.393s.23.344.246.53a1.236,1.236,0,0,1-.082.523A2.73,2.73,0,0,1,116.929,444.223Z",
    transform: "translate(-116.626 -442.586)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.904 4.772)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M103.527,434.977c-.012.023.3.151.708.484a3.637,3.637,0,0,1,1.272,3.676c-.116.515-.281.807-.257.818a.67.67,0,0,0,.125-.2,3.028,3.028,0,0,0,.228-.6,3.529,3.529,0,0,0-1.308-3.778,3.1,3.1,0,0,0-.548-.328A.674.674,0,0,0,103.527,434.977Z",
    transform: "translate(-103.527 -434.975)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.901 1.335)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M107.451,430.426a40.648,40.648,0,0,0-2.6,4,40.529,40.529,0,0,0,2.6-4Z",
    transform: "translate(-104.846 -430.425)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.446 9.641)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M108.216,441.422a9.572,9.572,0,0,0,2.849,1.842c.019-.036-.647-.4-1.431-.912S108.241,441.39,108.216,441.422Z",
    transform: "translate(-108.215 -441.421)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.413 8.421)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M105.637,439.807c-.039.009-.033.169-.061.357s-.075.341-.039.36.149-.122.178-.341S105.674,439.8,105.637,439.807Z",
    transform: "translate(-105.525 -439.806)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.343 7.061)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M105.461,438.006c-.039.008-.039.15,0,.317s.1.3.134.288.039-.15,0-.317S105.5,438,105.461,438.006Z",
    transform: "translate(-105.432 -438.006)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.596 5.979)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M104.444,436.587c-.014.038.117.119.229.261s.167.284.207.278.043-.193-.1-.366S104.453,436.551,104.444,436.587Z",
    transform: "translate(-104.443 -436.574)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.968 5.325)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M103.626,435.713c-.032.023-.007.109.054.193s.137.131.168.108.007-.109-.054-.192S103.656,435.69,103.626,435.713Z",
    transform: "translate(-103.612 -435.708)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.425)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.897)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "matrix(1, 0, 0, 1, -49.56, -109.64)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M157.525,282.987s9.851,65.448,8.418,68.611-47.424,53.741-47.424,53.741l-16.95-11.231s40.173-50.579,39.87-51.794-15.224-64.592-15.224-64.592Z",
    transform: "translate(-52.01 -168.08)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.636)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "t",
    transform: "matrix(1, 0, 0, 1, -67.2, -108.74)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M126.334,276.536l-.6,2.429a28.587,28.587,0,0,0,3,21.092l26.712,46.3a37.2,37.2,0,0,1,4.093,10.525l12.059,53.481h18.606c0,1.114-4.814-44.056-7.225-59.058-1.82-11.315-16.96-46.435-24.3-63.02l4.544-5.591-7.894-1.318Z",
    transform: "translate(-57.72 -167.79)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.985 11.625)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M170.394,291.926a3.43,3.43,0,0,1,.412.736c.242.484.576,1.193.976,2.074.8,1.762,1.85,4.223,2.921,6.975s1.958,5.278,2.559,7.118c.3.919.533,1.667.682,2.188a3.5,3.5,0,0,1,.193.82,3.481,3.481,0,0,1-.339-.772l-.8-2.145c-.668-1.814-1.595-4.318-2.663-7.066s-2.076-5.22-2.81-7.008q-.508-1.25-.86-2.122A3.522,3.522,0,0,1,170.394,291.926Z",
    transform: "translate(-170.39 -291.926)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.227 42.182)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M166.191,379.45a2.661,2.661,0,0,1-.121-.521l-.27-1.5q-.084-.5-.185-1.086-.133-.595-.285-1.281c-.206-.918-.417-1.969-.751-3.105l-.487-1.793-.611-1.919c-.4-1.335-.949-2.719-1.477-4.191-1.147-2.913-2.543-6.063-4.172-9.289a174.827,174.827,0,0,0-9.388-15.959l-3.1-4.685-.841-1.277a2.72,2.72,0,0,1-.27-.461,2.789,2.789,0,0,1,.336.415l.9,1.234c.777,1.076,1.879,2.65,3.206,4.619a154.461,154.461,0,0,1,9.506,15.935c1.635,3.238,3.026,6.4,4.16,9.337.521,1.484,1.064,2.876,1.45,4.222q.307,1,.592,1.934.242.942.465,1.808c.318,1.146.511,2.2.7,3.131l.254,1.291q.083.595.153,1.1c.082.627.147,1.131.2,1.517A2.7,2.7,0,0,1,166.191,379.45Z",
    transform: "translate(-144.233 -332.379)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.482 114.675)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M121.671,439.482a3.262,3.262,0,0,1-.776-.255,18.836,18.836,0,0,1-2.021-.931,46.866,46.866,0,0,1-6.143-3.994c-2.292-1.709-4.352-3.26-5.908-4.291s-2.561-1.6-2.53-1.658a3.222,3.222,0,0,1,.748.329c.473.229,1.133.605,1.934,1.1,1.6.977,3.7,2.5,5.99,4.208a60.6,60.6,0,0,0,6.043,4.066C120.628,438.973,121.7,439.417,121.671,439.482Z",
    transform: "translate(-104.292 -428.35)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.694 130.633)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M204.948,449.9a2.932,2.932,0,0,1-.773.044l-2.1-.015-6.933-.058-6.934.043-2.1.01a2.922,2.922,0,0,1-.773-.045,2.934,2.934,0,0,1,.767-.107c.5-.045,1.213-.091,2.1-.135,1.775-.09,4.23-.162,6.943-.159s5.167.08,6.942.174c.888.047,1.605.1,2.1.14A2.925,2.925,0,0,1,204.948,449.9Z",
    transform: "translate(-185.328 -449.476)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.844 11.731)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M140.138,178.309a8.479,8.479,0,0,1-4.784-.722,4.5,4.5,0,0,1-2.521-3.916,14.77,14.77,0,0,0,.287-2.846,9.041,9.041,0,0,0-1.313-2.55,5.291,5.291,0,0,1,1.419-6.477c.99-.754,2.254-1.149,3.083-2.076.982-1.1,1.139-2.683,1.739-4.028a6.518,6.518,0,0,1,4.852-3.718,20.778,20.778,0,0,0,3.481-.425,11.933,11.933,0,0,0,2.574-1.533,11.915,11.915,0,0,1,8.879-1.664,7.125,7.125,0,0,1,3.6,1.771c1.078,1.072,2.472,2.234,2.861,3.7.459,1.734-.1,3.909-.569,5.641A4.634,4.634,0,0,1,160.089,163",
    transform: "translate(-131.248 -148.106)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.506 7.652)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.003)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M142.512,194.145l14.185.2c.242-1.635.724-8.006.724-8.006s5.944-.36,6.568-6.21.875-19.395.875-19.395h0a20.448,20.448,0,0,0-20.7.646l-.931.586Z",
    transform: "translate(-142.512 -158.236)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.495 25.133)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M159.865,194.4a13.683,13.683,0,0,1-7.431-2.889s1.408,4.385,7.3,4.408Z",
    transform: "translate(-152.434 -191.508)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.834)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M142.336,171.31c-.116-.048-4.01-.683-3.79,3.947s4.822,2.876,4.824,2.743S142.336,171.31,142.336,171.31Z",
    transform: "translate(-138.537 -171.255)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.186 1.565)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M142.259,176.95c-.021-.014-.079.06-.212.129a.808.808,0,0,1-.6.041,2,2,0,0,1-1.008-1.746,2.654,2.654,0,0,1,.171-1.166.929.929,0,0,1,.577-.647.411.411,0,0,1,.486.2c.068.127.043.221.068.227s.1-.082.049-.272a.517.517,0,0,0-.2-.281.606.606,0,0,0-.452-.1,1.134,1.134,0,0,0-.808.758,2.745,2.745,0,0,0-.218,1.3,2.1,2.1,0,0,0,1.271,1.943.866.866,0,0,0,.732-.157C142.256,177.062,142.275,176.957,142.259,176.95Z",
    transform: "translate(-140.107 -173.328)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M141.625,162.1l.659,4.27a3.558,3.558,0,0,0,.677,1.885,2.539,2.539,0,0,0,3.1.2,7.4,7.4,0,0,0,2.785-3.922,12.1,12.1,0,0,1,2.275-4.3,5.638,5.638,0,0,0,6.5,1.2c.944-.475,1.73-1.211,2.636-1.754a3.456,3.456,0,0,1,3.014-.484c.536.222,1.017.662,1.6.636a1.29,1.29,0,0,0,1.039-.715,2.209,2.209,0,0,0,.191-1.286,5.056,5.056,0,0,0-3.013-3.661,15.632,15.632,0,0,0-6.893-1.183,26.059,26.059,0,0,0-6.647.657,11.49,11.49,0,0,0-5.726,3.287,7.425,7.425,0,0,0-1.9,6.181",
    transform: "translate(-133.787 -149.299)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M165.931,158.083a7,7,0,0,0,2.228,3.867,3,3,0,0,0,1.96.878,2.43,2.43,0,0,0,2.138-2.426,4.631,4.631,0,0,0-1.449-3.163,4.392,4.392,0,0,0-2.947-1.555,2.249,2.249,0,0,0-2.356,1.976",
    transform: "translate(-139.629 -149.959)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.131 66.152)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M166.134,224.094l11.788-3.942s8.21,19.415,10.322,19.608c11.7,1.067,24.225-2.813,28.616-4.347.446-.5.954-1.1,1.521-1.836a7.017,7.017,0,0,0,1.1-2.1,10.669,10.669,0,0,0,.626-2.892.918.918,0,0,1,1.578-.723c.507.654.636,3.163-.519,5.861s2.933.551,4.438-.2,6.267-2.874,6.866-2.6c.878.409.6,1.425-.919,2.144-1.538.728-5.924,3.2-5.487,3.972s8.035-3.186,8.035-3.186,1.489-1.107,2.024-.228c.965,1.585-7.428,5.189-8.235,5.511-.56.225-.116,1.084.474.811.607-.282,7.493-4.117,8.492-2.512.765,1.231-6.877,3.028-7.863,4.617s5.657-1.952,6.34-.746c.255.449.382.819-3.727,2.3a87.338,87.338,0,0,1-9.157,2.338l.014.042s-42.29,18.925-49.9.662C164.818,228.041,166.134,224.094,166.134,224.094Z",
    transform: "translate(-166.049 -220.152)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M170.775,221.743c-4.717-11.051-10.9-15.38-14.164-16.978a9.462,9.462,0,0,0-3.651-.939h0l-.392-1.9-15.64-1.408-.383,2.416-2.295-.124s-13.483,1.349-13.507,16.966c-.011,7.3,3.933,14.411,5.325,17.892.868,7.285-2.257,20.49-2.172,23.712l38.32,2.719,1.622-23.953-.359-2.247,12.615-3.863Zm-33.847-18.786h0Z",
    transform: "translate(-105.834 -149.197)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.33)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M266.007,153.295a44.522,44.522,0,0,0-78.918,23.226h0a44.489,44.489,0,0,0,15.03,38.27l-38.972,45.734,5.593,4.766,39.3-46.12a44.252,44.252,0,0,0,18.587,6.35,45.289,45.289,0,0,0,4.815.258,44.526,44.526,0,0,0,34.565-72.484ZM268.32,185.2a37.171,37.171,0,1,1-8.032-27.294A36.931,36.931,0,0,1,268.32,185.2Z",
    transform: "translate(-159.538 -133.592)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M261.7,149.142a44.522,44.522,0,0,0-78.918,23.226h0a44.492,44.492,0,0,0,15.031,38.27l-39.444,46.108,5.979,4.782,39.386-46.51a44.252,44.252,0,0,0,18.587,6.35,45.314,45.314,0,0,0,4.816.258A44.526,44.526,0,0,0,261.7,149.142Zm2.314,31.908a37.173,37.173,0,1,1-8.033-27.294A36.931,36.931,0,0,1,264.015,181.05Z",
    transform: "translate(-158.369 -132.576)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.413 28.002)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M219.936,210.288a1.867,1.867,0,0,1-.294-.327c-.177-.226-.456-.548-.773-.993a33.835,33.835,0,0,1-2.481-3.911,36.826,36.826,0,0,1-2.52-29.656,33.927,33.927,0,0,1,1.786-4.272c.236-.493.457-.857.594-1.11a1.8,1.8,0,0,1,.234-.372,1.84,1.84,0,0,1-.164.408c-.114.264-.312.638-.526,1.139a40.433,40.433,0,0,0-1.66,4.294,37.829,37.829,0,0,0,2.5,29.437,40.252,40.252,0,0,0,2.361,3.954c.3.458.554.793.711,1.034A1.844,1.844,0,0,1,219.936,210.288Z",
    transform: "translate(-211.87 -169.647)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.611 22.912)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M224.45,162.922c.066.091-.388.514-.841,1.109s-.75,1.137-.856,1.1.045-.692.544-1.337S224.393,162.835,224.45,162.922Z",
    transform: "translate(-222.724 -162.908)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.796 51.686)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.697 12.513)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M173.155,217.567a5.581,5.581,0,0,1,.274,1.042c.153.677.351,1.66.579,2.878.457,2.435,1.008,5.817,1.472,9.57s.752,7.17.9,9.644c.075,1.237.121,2.238.137,2.932a5.682,5.682,0,0,1-.011,1.078,5.63,5.63,0,0,1-.141-1.069c-.069-.764-.157-1.744-.263-2.92-.22-2.465-.551-5.868-1.013-9.616s-.97-7.127-1.356-9.572c-.184-1.166-.337-2.138-.456-2.9A5.735,5.735,0,0,1,173.155,217.567Z",
    transform: "translate(-173.147 -217.567)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.153 23.827)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M182.489,258.336s-42.276,18.967-49.881.7c-7.748-18.605-6.432-22.552-6.432-22.552l11.788-3.942s8.209,19.415,10.322,19.608c11.7,1.067,24.225-2.813,28.616-4.347.446-.5.955-1.1,1.521-1.837.486-.632.992-1.541,1.49-2.164a15.632,15.632,0,0,1,2.488-2.183c1.168-1.32,2.234-.356,1.727.355a12.73,12.73,0,0,0-2.918,4.136c-1.155,2.7,2.961,1.373,4.589.944,1.8-.474,5.18-1.787,5.18-1.787a3.958,3.958,0,0,1-2.338,3.106,24.143,24.143,0,0,1-2.533,1.054s3.125-.379,3.208.332-.925,5.981-4.25,7.546Z",
    transform: "translate(-126.092 -232.545)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M134.2,210.139l7.594,22.943-16.621,6.57s-8.672-22.53,2.31-28.046Z",
    transform: "translate(-121.918 -203.236)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.21 3.521)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.611)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M145.428,231.093c-.008.007-.093-.06-.225-.215a4.229,4.229,0,0,1-.5-.738,25.242,25.242,0,0,1-1.2-3.018c-.931-2.571-2.191-6.132-3.561-10.073l-1.916-5.561a13.808,13.808,0,0,0-1.916-4.313,3.5,3.5,0,0,0-2.716-1.349,3.435,3.435,0,0,0-1.126.27c-.006-.009.075-.08.255-.179a2.232,2.232,0,0,1,.863-.244A3.6,3.6,0,0,1,136.326,207a13.507,13.507,0,0,1,2.047,4.374c.6,1.713,1.256,3.586,1.944,5.55,1.369,3.941,2.588,7.516,3.451,10.111.44,1.3.744,2.361,1.073,3.041S145.456,231.07,145.428,231.093Z",
    transform: "translate(-132.272 -205.663)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 25.855)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M143.582,239.895a2.718,2.718,0,0,1-.629.394c-.416.233-1.027.551-1.79.928-1.526.758-3.666,1.74-6.076,2.713s-4.634,1.749-6.258,2.262c-.812.257-1.473.452-1.934.574a2.742,2.742,0,0,1-.727.153,21.968,21.968,0,0,1,2.571-.99c1.6-.579,3.8-1.4,6.2-2.364s4.552-1.909,6.1-2.6A22.19,22.19,0,0,1,143.582,239.895Z",
    transform: "translate(-126.168 -239.891)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.399 28.634)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M129.389,246.984a8.637,8.637,0,0,1-1.345-3.413,8.648,8.648,0,0,1,1.345,3.413Z",
    transform: "translate(-128.019 -243.57)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.051 27.404)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M134.08,245.237c-.092.051-.552-.613-.884-1.542a3.2,3.2,0,0,1-.3-1.752,18.863,18.863,0,0,1,1.181,3.295Z",
    transform: "translate(-132.854 -241.941)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.652 25.703)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M138.93,243.092a5.105,5.105,0,0,1-1.262-3.4,27.391,27.391,0,0,1,1.262,3.4Z",
    transform: "translate(-137.622 -239.69)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.733 23.894)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M144.187,240.913a9.222,9.222,0,0,1-1.132-3.617,9.233,9.233,0,0,1,1.132,3.617Z",
    transform: "translate(-143.024 -237.295)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.848 30.489)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.405)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M190.237,244.557a58.582,58.582,0,0,1-6.4,2.244,58.6,58.6,0,0,1-6.52,1.87,58.622,58.622,0,0,1,6.4-2.244A58.6,58.6,0,0,1,190.237,244.557Z",
    transform: "translate(-177.319 -244.549)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.642 2.446)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M180.644,247.237c-.1.043-.432-.512-.743-1.239s-.48-1.351-.38-1.394.432.512.742,1.24S180.744,247.194,180.644,247.237Z",
    transform: "translate(-179.493 -244.602)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.125 1.199)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M185.025,246.1c-.1.041-.457-.616-.7-1.5a2.98,2.98,0,0,1-.164-1.646c.11-.017.307.684.543,1.542A4.431,4.431,0,0,1,185.025,246.1Z",
    transform: "translate(-184.104 -242.952)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.83)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M189.72,244.591a6.99,6.99,0,0,1-.659-3.226,6.995,6.995,0,0,1,.659,3.226Z",
    transform: "translate(-189.009 -241.364)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.703)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M144.172,202.846c-.109-.008-.168-.427-.131-.936s.153-.916.261-.909.167.427.131.936S144.28,202.853,144.172,202.846Z",
    transform: "translate(-144.03 -201.001)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.052 0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M148.7,203.109c-.109,0-.213-.4-.233-.913s.051-.925.159-.93.213.4.233.914S148.81,203.105,148.7,203.109Z",
    transform: "translate(-148.464 -201.266)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.762 0.595)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M152.242,203.7c-.109,0-.193-.429-.19-.956s.1-.954.2-.953.193.429.189.956S152.35,203.7,152.242,203.7Z",
    transform: "translate(-152.052 -201.788)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.21 0.66)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M156.955,204.114c-.1.027-.318-.463-.336-1.11s.165-1.15.269-1.129.1.517.125,1.117S157.063,204.087,156.955,204.114Z",
    transform: "translate(-156.617 -201.874)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.139 0.661)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M160.865,204.115c-.108.013-.255-.478-.329-1.1s-.046-1.129.062-1.143.255.478.329,1.1S160.973,204.1,160.865,204.115Z",
    transform: "translate(-160.494 -201.876)"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(328.954 378.482)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(139.724 265)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.595 5.922)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M472.1,73.343l-8.635,22.09,5.368-.024,4.3-13.575Z",
    transform: "translate(-463.462 -52.932)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.998)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M452.991,46.322l2.968,42.326-30.644.64-3.448-42.966Z",
    transform: "translate(-421.867 -46.322)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M450.076,50.767,452.547,86l-22.78,1.067-3.183-36.506Z",
    transform: "translate(-422.018 -47.358)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M446.962,57.43l1.848,24.764H436.244L434.027,57.43Z",
    transform: "translate(-423.903 -49.039)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.158)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M401.3,95.844V74.653H385.786V95.827Z",
    transform: "translate(-385.524 -47.331)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M393.717,65.8s-3.744-27.36-2.7-27.322S394.7,63.427,394.7,63.427s.11-20.628,1.1-20.518,0,21.835,0,21.835,1.687-17.631,2.6-17.209-.391,18.269-.391,18.269h-4.292",
    transform: "translate(-386.759 -38.482)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M401.724,67.65s-1.3-13.637-1.725-12.7,0,8.119,0,8.119-3.593-17.622-4.534-17.024,3.678,19.127,3.678,19.127-3.507-10.578-4.277-9.463,2.909,11.037,2.909,11.037-3.764-7.014-4.021-6.073,1.8,6.981,1.8,6.981Z",
    transform: "translate(-391.946 -40.327)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M382.866,69.647s8.3-16.289,7.272-15.783-6.331,11.026-6.331,11.026,3.51-10.156,2.739-10.467-4.621,11.408-4.621,11.408l-.864,3.816Z",
    transform: "translate(-370.877 -42.242)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M386.251,74.677l-.392,21.191h7.378l.142-21.262Z",
    transform: "translate(-377.654 -47.319)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M401.3,76.474l-7.146.119-8.354-.119-.262-2.025h15.966Z",
    transform: "translate(-385.541 -47.281)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 108.646,
    height: 5.596,
    transform: "translate(0.001 47.923)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 141.843)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M117.395,226.262,118.962,403H48.954V228.672Z",
    transform: "translate(-48.954 -226.262)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.328)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M79.68,228.02,80.3,403.428H48.954V229.1Z",
    transform: "translate(-48.954 -228.02)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.079 2.18)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M125.907,229.148v24.773H92.746v-23.6Z",
    transform: "translate(-92.746 -229.148)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.251 6.482)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.333)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M118.227,238.063v3.659H108.081V237.73Z",
    transform: "translate(-108.081 -237.73)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.068)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 10.478,
    height: 1.497
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.079 88.991)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M125.907,344.074v24.773H92.746v-23.6Z",
    transform: "translate(-92.746 -344.074)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.251 6.483)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.333)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M118.227,352.988v3.66H108.081v-3.992Z",
    transform: "translate(-108.081 -352.656)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.069)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 10.478,
    height: 1.497
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.079 30.107)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M125.907,266.119v24.773H92.746v-23.6Z",
    transform: "translate(-92.746 -266.119)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.251 6.483)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.333)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M118.227,275.034v3.659H108.081V274.7Z",
    transform: "translate(-108.081 -274.702)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.068)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 10.478,
    height: 1.497
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.079 116.913)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M125.907,381.038v24.773H92.746v-23.6Z",
    transform: "translate(-92.746 -381.038)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.584 6.482)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M118.227,389.953v3.659H108.081V389.62Z",
    transform: "translate(-108.081 -389.62)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.251 13.551)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 10.478,
    height: 1.497
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.436 144.834)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M126.38,418v24.773H93.219v-23.6Z",
    transform: "translate(-93.219 -418.002)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.583 6.482)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M118.7,426.917v3.659H108.554v-3.992Z",
    transform: "translate(-108.554 -426.584)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.251 13.551)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 10.478,
    height: 1.497
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.511 59.769)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 33.161,
    height: 24.773
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.969 10.853)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M118.7,320.068v3.44h-9.537v-3.752Z",
    transform: "translate(-109.163 -319.755)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.656 17.497)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 9.849,
    height: 1.407
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(270.042 290.979)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.786 6.037)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M410.14,431.69v21.594h66.408V431.69Z",
    transform: "translate(-410.14 -431.69)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M406.451,423.7v6.037h71.517V423.7H406.451Z",
    transform: "translate(-406.451 -423.697)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.365)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M453.339,451.329h33.436V429.734H489.1V423.7H451.946v5.479Z",
    transform: "translate(-451.946 -423.697)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.074 9.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 13.467,
    height: 3.251
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.341 16.834)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 17.293,
    height: 6.864
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(355.84 263.347)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.786 6.037)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M523.725,395.109V416.7h66.408V395.109Z",
    transform: "translate(-523.725 -395.109)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M520.036,387.117v6.037h71.517v-6.037H520.036Z",
    transform: "translate(-520.036 -387.117)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.365)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M566.924,414.748H600.36V393.154h2.322v-6.037H565.531V392.6Z",
    transform: "translate(-565.531 -387.117)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.074 9.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 13.467,
    height: 3.251
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.341 16.834)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 17.293,
    height: 6.864
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(352.66 290.979)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.786 6.037)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M519.516,431.69v21.594h66.408V431.69Z",
    transform: "translate(-519.516 -431.69)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M515.827,423.7v6.037h71.517V423.7H515.827Z",
    transform: "translate(-515.827 -423.697)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.365)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M562.714,451.329h33.436V429.734h2.322V423.7H561.321v5.479Z",
    transform: "translate(-561.321 -423.697)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.074 9.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 13.467,
    height: 3.251
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.341 16.834)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 17.293,
    height: 6.864
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(370.164 71.075)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 48.789,
    height: 54.555,
    transform: "translate(67.22 109.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M61.056,549.29H36.218L33.557,528h30.16Z",
    transform: "translate(-18.673 -357.269)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M379.665,701.824l-.838,11.459a3.648,3.648,0,0,0,3.859,3.907l5.886-.357a1.861,1.861,0,0,0,1.692-2.308L387,701.457Z",
    transform: "translate(-287.407 -470.838)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M490.687,708.82c6.927,1.62,11.875,3.924,15.126,7.041a6.669,6.669,0,0,0,4.268,1.83,10.91,10.91,0,0,0,4.958-.681h0a1.965,1.965,0,0,0,1.164-1.619,2,2,0,0,0-.838-1.848l-16.428-11.689-6.978,2.792-1.628,1.628a1.612,1.612,0,0,0,.355,2.547Z",
    transform: "translate(-349.199 -471.058)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M384.747,232.171l-46.958-.435a40.114,40.114,0,0,1,5.188-19.566c2.285-3.947,2.235-8.243,1.685-11.862a15.949,15.949,0,0,1,5.516-14.854,17.7,17.7,0,0,1,11.906-3.939l.912.038a17.745,17.745,0,0,1,14.579,8.769,14.782,14.782,0,0,1,1.757,9,14.912,14.912,0,0,0,2.08,8.872C384.285,214.754,384.908,223.144,384.747,232.171Z",
    transform: "translate(-264.576 -181.499)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "s",
    transform: "matrix(1, 0, 0, 1, -370.16, -4.53)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M411.43,557.94l-9.216,2.4-44.878-97.771,2.8,95.367h-9.216c-9.848-44.867-27.628-96.649-19.634-113l47.683-2.8Z",
    transform: "translate(110.32 -322)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "h",
    cx: 12.422,
    cy: 12.422,
    rx: 12.422,
    ry: 12.422,
    transform: "translate(84.672 9.417)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M390.384,264.134l-20.436-1.2c2-4.6,2.8-9.023,2-13.223h15.227C387.144,252.933,388.749,258.511,390.384,264.134Z",
    transform: "translate(-282.472 -219.455)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "r",
    transform: "matrix(1, 0, 0, 1, -370.16, -4.53)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M215.906,187.666l-44.878,3.206,4.608-79.539,7.814-2.2,8.815,2,8.815-4.408,5.61,2Z",
    transform: "translate(274.99 -63.93)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M322.456,406.018,291.8,399.006c9.115-30.226,25.536-99.374,20.235-124.017l16.028-7.213Z",
    transform: "translate(-238.986 -229.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M312.908,325.7l-11.62-7.213,9.91-29.025a13.692,13.692,0,0,1,5.985-7.109l3.338-1.933-2,29.251Z",
    transform: "translate(-244.265 -236.548)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M448.135,398.4c-9.675,5.6-33.859,8.718-44.478,4.808-.781-27.31-2.314-104.558,2.6-137.24l17.631,7.213-1.6,21.638C413.861,313.33,438.337,377.8,448.135,398.4Z",
    transform: "translate(-300.754 -228.504)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M297.455,162.052l-10.819-3.606-14.425-16.429,2.4-20.836,24.042,33.659Z",
    transform: "translate(-151.476 -76.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M425.309,402.426a3.01,3.01,0,0,0,3.595,2.268l9.184-2.08-1.327-5.862-9.184,2.079a3.006,3.006,0,0,0-2.267,3.595Z",
    transform: "translate(-313.237 -301.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M386.865,210.438a26.463,26.463,0,0,0-20.436-.4l-2.8-10.018h25.645Z",
    transform: "translate(-278.953 -191.805)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M444.029,374.147l5.209,9.617c8.762-2.444,16.355-10.148,23.641-19.234l-2-6.411-12.422,3.206Z",
    transform: "translate(-323.695 -279.782)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M421.37,299.264h-1.6c0-22.669-4.668-38.467-9.216-38.467l-.4-1.6c4.079,0,6.68,6.575,8.143,12.091C420.278,278.763,421.37,288.7,421.37,299.264Z",
    transform: "translate(-304.843 -224.734)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M350.321,294.66h-1.6c0-20.761,4.7-33.659,11.62-33.659l-.4,1.6C355.151,262.6,350.321,272.516,350.321,294.66Z",
    transform: "translate(-270.658 -225.739)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "p",
    cx: 4.007,
    cy: 4.007,
    rx: 4.007,
    ry: 4.007,
    transform: "translate(111.719 70.924)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M335.866,345.5h-1.6c0-5.745,3.236-10.418,7.213-10.418v1.6C338.383,336.685,335.866,340.639,335.866,345.5Z",
    transform: "translate(-262.614 -266.963)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M357.737,345.5h-1.6c0-4.861-2.517-8.815-5.61-8.815v-1.6C354.5,335.082,357.737,339.756,357.737,345.5Z",
    transform: "translate(-271.663 -266.963)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "p",
    cx: 1.603,
    cy: 1.603,
    rx: 1.603,
    ry: 1.603,
    transform: "translate(83.67 77.335)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "p",
    cx: 1.603,
    cy: 1.603,
    rx: 1.603,
    ry: 1.603,
    transform: "translate(70.848 77.335)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "q",
    transform: "matrix(1, 0, 0, 1, -370.16, -4.53)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M118.177,165.193l10,1.786,22.857,32.5-12.143-2.857Z",
    transform: "translate(304.4 -96.46)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M285.849,325.347a.851.851,0,0,0-.7,1.318l21.366,32.417a.848.848,0,0,0,.515.359l9.941,2.339a.849.849,0,0,0,.889-1.315L294.4,327.111a.844.844,0,0,0-.545-.347l-7.848-1.4a.919.919,0,0,0-.16-.014Z",
    transform: "translate(-235.207 -261.546)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M316.949,376.419l.594,5.981,9.37-.93a3.005,3.005,0,0,0-.594-5.981Z",
    transform: "translate(-252.979 -289.439)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M298.578,369.752a7.729,7.729,0,0,0,7.72,7.678h1.541l1.122-9.348-9.288-3.344Z",
    transform: "translate(-242.757 -283.466)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M192.694,644.257c6.4,8.565,19.672,9.467,19.672,9.467s2.907-12.985-3.489-21.55-19.672-9.466-19.672-9.466S186.3,635.692,192.694,644.257Z",
    transform: "translate(-181.527 -481.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M254.523,660.713c-4.22,5.652-12.981,6.247-12.981,6.247s-1.918-8.569,2.3-14.22,12.981-6.247,12.981-6.247S258.744,655.061,254.523,660.713Z",
    transform: "translate(-210.776 -494.638)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptysearchscreen);
export default __webpack_public_path__ + "static/media/emptysearchscreen.87cae1f1ebb3716d9282c897163e8d85.svg";
export { ForwardRef as ReactComponent };